import React from "react";

function TableHead({ thead }) {
  return (
    <>
      {thead.map((item, index) => {
        return <th key={index} scope="col">{item}</th>;
      })}
    </>
  );
}

export default TableHead;
